<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title">{{ $t("FnB Sales Combo Report") }}</div>
      <div class="mt-3 mb-2">
        <div class="row">
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label
                :class="
                  dropDown.cinemas && dropDown.cinemas.length > 0
                    ? 'shift-up'
                    : ''
                "
                >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
              >
              <!-- <b-dropdown
                :disabled="isRoleID"
                :text="selected.cinema"
                variant="dropdown-curve"
                class="w-100"
              >
                <b-dropdown-item
                  v-for="(Cinema, CinemaIndex) in CinemasList"
                  :key="CinemaIndex"
                  v-on:click="onSelectCinema($event, Cinema)"
                >{{ Cinema.cine_name }}</b-dropdown-item>
              </b-dropdown>-->
              <multiselect
                :disabled="isRoleID"
                :options="dropDown.cinemas"
                v-model="dropDown.selectedCinema"
                :searchable="true"
                label="cine_name"
                track-by="cine_id"
                placeholder="Select Cinema"
                @input="onSelectCinema($event)"
                :allowEmpty="false"
                :showLabels="false"
                :multiple="true"
                :taggable="true"
              ></multiselect>
            </div>
          </div>
          <div class="col-lg-6 col-xl-2 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <button class="btn-clearDate" v-if="fromDate">
                  ✖
                </button>
                <Datepicker
                  :monday-first="true"
                  type="date"
                  ref="programaticOpen"
                  v-model="fromDate"
                  v-validate="'required'"
                ></Datepicker>
                <label :class="fromDate ? 'active' : ''">
                  {{ $t("show") }}
                  {{ $t("fromdate") }}
                </label>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-xl-2 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <button class="btn-clearDate" v-if="toDate">
                  ✖
                </button>
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="toDate"
                  v-validate="'required'"
                ></Datepicker>
                <label :class="toDate ? 'active' : ''"
                  >{{ $t("show") }} {{ $t("todate") }}</label
                >
              </div>
            </div>
          </div>

          <div class="col-lg-6 col-xl-2 align-self-center mb-3">
            <button
              class="btn-blue-lg w-100"
              @click.prevent="getFnBComboReportData"
            >
              {{ $t("fetch") }}
              {{ $t("report") }}
            </button>
          </div>

          <div
            v-if="getFnBComboReport.length > 0"
            class="col-lg-6 col-xl-3 align-self-center mt-2 d-flex justify-content-end align-items-center"
          >
            <span class="mx-1">Download as</span>
            <img
              class=""
              @click="excelDownload()"
              src="@/assets/img/icons/excel.svg"
              height="25"
              width="25"
            />
          </div>
          <!-- <div
          class="d-flex justify-content-end mt-5 align-items-center"
          v-if="getFnBComboReport.length"
        >
          <div>{{ $t("download") }} as:</div>
          <a target="_blank" download title="Download as PDF">
            <img src="@/assets/img/icons/pdf-icon.svg" height="25" width="25" />
          </a>
          <a href="#" @click="excelDownload()" title="Download as Excel">
            <img src="@/assets/img/icons/excel.svg" height="25" width="25" />
          </a>
        </div> -->
        </div>
      </div>

      <div>
        <div class="table-scroll">
          <table
            class="swc-report-table swc_table_header"
            border="1"
            v-if="getFnBComboReport.length > 0"
          >
            <thead class="bg-lightblue font-weight-bold text-light">
              <!-- <th>Cinema Name</th> -->
              <th>Date</th>
              <th>Combo</th>
              <th>Combo Items</th>
              <th>Qty</th>
              <th>Price</th>
              <th>Value</th>
            </thead>
            <tbody>
              <template
                v-for="(fnbComboData, fnbComboDataIndex) in getFnBComboReport"
              >
                <tr :key="fnbComboDataIndex + 'fnb_cinema_name'">
                  <td colspan="6" class="bg-lightgrey font-weight-bold">
                    {{ fnbComboData.cinema_name }}
                  </td>
                </tr>
                <template
                  v-for="(fnbDate, fnbDateIndex) in fnbComboData.dateObj"
                >
                  <tr :key="fnbDateIndex + 'fnb_date'">
                    <td
                      :rowspan="fnbDate.dateBasedData.length + 1"
                      v-if="fnbDate.dateBasedData.length > 0"
                    >
                      {{ fnbDate.date }}
                    </td>
                    <!-- <td v-if="fnbDate.dateBasedData.length > 1"></td> -->
                  </tr>

                  <template
                    v-for="(fnbbaseDate,
                    fnbbaseDateIndex) in fnbDate.dateBasedData"
                  >
                    <tr :key="fnbbaseDateIndex + 'fnb_datebase'">
                      <!-- <td v-if="fnbDate.dateBasedData.length > 1"></td> -->
                      <td class="text-left">
                        {{ fnbbaseDate.fst_item_name }}
                      </td>
                      <td class="text-left">
                        {{ fnbbaseDate.combo_items_data }}
                      </td>
                      <td class="text-right">
                        {{ fnbbaseDate.fst_quantity_total }}
                      </td>
                      <td class="text-right">
                        {{ fnbbaseDate.price.toFixed(2) }}
                      </td>
                      <td class="text-right">
                        {{
                          (
                            fnbbaseDate.price * fnbbaseDate.fst_quantity_total
                          ).toFixed(2)
                        }}
                      </td>
                    </tr>
                  </template>
                  <tr
                    class="bg-lightgrey"
                    :key="fnbDateIndex + 'rowone'"
                    v-if="fnbDate.dateBasedData.length > 0"
                  >
                    <td colspan="3" class="text-right font-weight-bold"
                      >Total</td
                    >
                    <td class="bg-lightgrey text-right">
                      {{
                        fnbDate.dateBasedData.reduce(
                          (acc, { fst_quantity_total }) => {
                            return acc + fst_quantity_total;
                          },
                          0
                        )
                      }}
                    </td>
                    <td class="bg-lightgrey text-right">
                      <!-- {{
                      fnbDate.dateBasedData.reduce((acc,{price})=>{
                        return acc+price
                      },0).toFixed(2)
                      }} -->
                    </td>
                    <td class="bg-lightgrey text-right">
                      {{
                        fnbDate.dateBasedData
                          .reduce((acc, { price, fst_quantity_total }) => {
                            return acc + price * fst_quantity_total;
                          }, 0)
                          .toFixed(2)
                      }}
                    </td>
                  </tr>
                </template>

                <tr
                  class="bg-lightgrey font-weight-bold"
                  :key="fnbDateIndex + 'rowtwo'"
                >
                  <td colspan="3" class="text-left">
                    <!-- Qty Total -->
                    Grand Total
                  </td>
                  <td class="bg-lightgrey text-right">
                    {{
                      fnbComboData.dateObj
                        .map((x) =>
                          x.dateBasedData.reduce(
                            (acc, { fst_quantity_total }) => {
                              return acc + fst_quantity_total;
                            },
                            0
                          )
                        )
                        .reduce((acc, a) => {
                          return acc + a;
                        })
                    }}
                  </td>
                  <td class="bg-lightgrey text-right">
                    <!--                    
                     {{
                      fnbComboData.dateObj.map((x=>x.dateBasedData.reduce((acc,{price})=>{
                        return acc+price
                      },0))).reduce((acc,a)=>{
                        return acc+a
                      }).toFixed(2)}} -->
                  </td>
                  <td class="bg-lightgrey text-right">
                    {{
                      fnbComboData.dateObj
                        .map((x) =>
                          x.dateBasedData.reduce(
                            (acc, { price, fst_quantity_total }) => {
                              return acc + price * fst_quantity_total;
                            },
                            0
                          )
                        )
                        .reduce((acc, a) => {
                          return acc + a;
                        })
                        .toFixed(2)
                    }}
                  </td>
                </tr>
                <!-- <tr
                  :key="fnbArrIndex + fnbComboDataIndex + 'grand_total'"
                  class="bg-lightgrey font-weight-bold"
                >
                  <td class="text-left" colspan="2">Total</td>
                  <td class="text-right">
                    {{
                      fnbComboData.fnbData.reduce(
                        (acc, { fst_quantity_total }) => {
                          return acc + fst_quantity_total;
                        },
                        0
                      )
                    }}
                  </td>
                  <td class="text-right">
                    {{
                      fnbComboData.fnbData
                        .reduce((acc, { price }) => {
                          return acc + price;
                        }, 0)
                        .toFixed(2)
                    }}
                  </td>
                  <td class="text-right">
                    {{
                      fnbComboData.fnbData
                        .reduce((acc, { fst_quantity_total, price }) => {
                          return acc + fst_quantity_total * price;
                        }, 0)
                        .toFixed(2)
                    }}
                  </td>
                </tr> -->
              </template>
            </tbody>
          </table>
        </div>
      </div>

      <table
        v-if="getFnBComboReport.length === 0"
        class="swc-report-table swc_table_header"
        border="1"
      >
        <thead class="bg-lightgrey">
          <!-- <th>Cinema Name</th> -->
          <th>Date</th>
          <th>Combo</th>
          <th>Combo Items</th>
          <th>Qty</th>
          <th>Price</th>
          <th>Value</th>
        </thead>
        <tbody>
          <tr>
            <td colspan="5">
              <!-- <div class="h6 my-3 text-center">{{ $t("NoRecords") }}</div> -->
              <NoRecords />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import { BASEURL } from "@/config/index";
import MasterService from "@/services/MasterService";
import ReportsService from "@/services/ReportsService-v2";
import moment from "moment";
import NoRecords from "@/components/Partials/NoRecords.vue";
import xlsx from "json-as-xlsx";

export default {
  components: {
    NoRecords,
  },
  data() {
    return {
      BASEURL,
      isRoleID: false,
      submitted: false,
      dropDown: {
        cinemas: [],
        selectedCinema: null,
        selectedCinemaName: null,
        selectedCinemaId: "",
      },
      fromDate: new Date(),
      toDate: new Date(),
      getFnBComboReport: [],
      getFnBComboReportRecords: [],
      Allrecords: [],
      mainArr: [],
    };
  },
  beforeMount() {
    // let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    this.getCinemaList();
    // if (CinemaObj) {
    //   this.onSelectCinema(CinemaObj);
    // }
    this.getCinemaList();
  },
  watch: {
    // "$store.getters.getSelectedDropDownCinema": function(CinemaObj) {
    //   if (CinemaObj) {
    //     this.onSelectCinema(CinemaObj);
    //   }
    // }
  },
  mounted() {},
  methods: {
    excelDownload() {
      let temp_data = this.Allrecords;
      console.log(this.Allrecords);
      let temp_arr = [];
      temp_data.map((x) => {
        x.fnbData.map((y) => {
          y["combo_items_data"] = "";
          JSON.parse(y.combo_data).forEach((x) => {
            y["combo_items_data"] += y["combo_items_data"]
              ? `,${x.quantity}-${x.item_name}`
              : `${x.quantity}-${x.item_name}`;
          });
          let obj = {
            ...x,
            ...y,
          };
          temp_arr.push(obj);
        });
      });
      console.log({ temp_arr });
      let dateparse = function(value) {
        if (!value) return "-";
        else if (value === "Invalid date") return "-";
        else if (moment(value, "DD-MM-YYYY HH:mm", true).isValid())
          return value
            ? moment(value, "DD-MM-YYYY HH:mm").format("DD-MMM-YYYY")
            : "-";
        //else return value ? moment(value).format('DD-MM-YYYY') === 'Invalid date' ? '-' : moment(value).format('DD-MM-YYYY') : '-';
        //this is changed acc to mams decision
        else
          return value
            ? moment(value).format("DD-MM-YYYY") === "Invalid date"
              ? "-"
              : moment(value).format("DD-MMM-YYYY")
            : "-";
      };
      let fulldatemonparse = function(value) {
        if (!value) return "-";
        else if (value === "Invalid date") return "-";
        else if (moment(value, "DD-MM-YYYY HH:mm", true).isValid())
          return value
            ? moment(value, "DD-MM-YYYY HH:mm").format("DD-MMM-YYYY HH:mm")
            : "-";
        //else return value ? moment(value).format('DD-MM-YYYY') === 'Invalid date' ? '-' : moment(value).format('DD-MM-YYYY') : '-';
        //this is changed acc to mams decision
        else
          return value
            ? moment(value).format("DD-MM-YYYY") === "Invalid date"
              ? "-"
              : moment(value).format("DD-MMM-YYYY HH:mm")
            : "-";
      };

      let data = [
        {
          sheet: "Fnb Sales Report",
          columns: [
            {
              value: "ft_cinema_name",
              label: "Cinema",
            },
            {
              value: "date",
              label: "Date",
            },
            {
              value: "fst_item_name",
              label: "Combo",
            },
            {
              value: "combo_items_data",
              label: "Combo Items",
            },
            {
              value: "fst_quantity_total",
              label: "Qty",
            },
            {
              value: "price",
              label: "Price",
            },
            {
              value: (row) => row.price * row.fst_quantity_total,
              label: "value",
            },

            //      Sold: 0,
            // gross_amount: 0,
            // offer_price: 0,
            // total_taxes: 0,
            // final_gross_amount: 0
          ],
          content: temp_arr,
        },
      ];
      let settings = {
        fileName: `FnbSalesComboReport${new Date().getTime()}`,
      };
      xlsx(data, settings);
    },
    getCinemaList: function() {
      MasterService.GetCinemas()
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.dropDown.cinemas = data.Records;
            this.CinemasCopy = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })

        .catch(this._CatchError);
    },
    onSelectCinema: function(event) {
      console.log(event);
      this.dropDown.selectedCinema = event;
      this.dropDown.selectedCinemaName = event.cine_name;
      this.dropDown.selectedCinemaId = event.map((x) => {
        return x.cine_id;
      });

      // this.$store.dispatch("selectDropdownCinema", event);
    },

    getFnBComboReportData: function() {
      if (!this.dropDown.selectedCinemaId) {
        this.$toasted.show("Select Cinema");
        return;
      }

      let loader = this.$loading.show();
      this.submitted = true;

      let payload = {
        cinema_id: this.dropDown.selectedCinemaId,
        fromDate: moment(this.fromDate).format("YYYY-MM-DD"),
        toDate: moment(this.toDate).format("YYYY-MM-DD"),
      };
      ReportsService.GetFnBComboSalesReport(payload)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records) {
            // console.log("data from api", data.Records);
            data.cinemaBasedData.forEach((x) => {
              x.dateObj.map((z) => {
                // y.map((z) => {
                z.dateBasedData.map((zz) => {
                  zz["combo_items_data"] = "";
                  JSON.parse(zz.combo_data).map((combos) => {
                    zz["combo_items_data"] += zz["combo_items_data"]
                      ? `,${combos.quantity}-${combos.item_name}`
                      : `${combos.quantity}-${combos.item_name}`;
                  });
                });
                // });
              });
            });
            this.getFnBComboReport = data.cinemaBasedData;
            // this.dataObj = this.getFnBComboReport.dataOdj;
            this.getFnBComboReportRecords = data.orginal_Records;
            this.Allrecords = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError)
        .finally(() => {
          setTimeout(() => loader.hide(), 660);
        });
    },
    // getFnBComboReportData: function() {
    //   let loader = this.$loading.show();
    //   this.submitted = true;

    //   let payload = {
    //     cinema_id: this.dropDown.selectedCinemaId,
    //     fromDate: moment(this.fromDate).format("YYYY-MM-DD"),
    //     toDate: moment(this.toDate).format("YYYY-MM-DD")
    //   };
    //   ReportsService.GetFnBComboSalesReport(payload)
    //     .then(response => {
    //       const { data } = response;
    //       if (data.status && data.Records) {
    //         // console.log("data from api", data.Records);
    //         this.getFnBComboReport = data.Records;
    //         this.getFnBComboReportRecords = data.orginal_Records;
    //         let tempFnbRecords = this.getFnBComboReportRecords;
    //         let tempComboRecords = this.getFnBComboReport;
    //         let tempCinemaArr = [];
    //         let dateArr = [];
    //         let obj = {};
    //         let dataArr = [];
    //         tempFnbRecords.map(x => {
    //           // let findCinemaIndex = tempCinemaArr.findIndex(i => {
    //           //   return i.cinema_id == x.cinema_id;
    //           // });
    //           let findDateIndex = dataArr.findIndex(d => {
    //             return d.cinema_id == x.cinema_id;
    //           });
    //           if (findDateIndex < 0) {
    //             let testArr = [];
    //             tempComboRecords.map(b => {
    //               testArr = b.fnbData.filter(d => {
    //                 return d.cinema_id == x.cinema_id;
    //               });
    //               return testArr;
    //             });
    //             dataArr.push({
    //               cinema_id: x.cinema_id,
    //               cinema_name: x.ft_cinema_name,
    //               addDateArr: testArr
    //             });
    //           }
    //           this.mainArr = dataArr;
    //         });
    //       } else {
    //         this.$toasted.show(data.message);
    //       }
    //     })
    //     .catch(this._CatchError)
    //     .finally(() => {
    //       setTimeout(() => loader.hide(), 660);
    //     });
    // },
  },
};
</script>

<style>
.concession-analysis-table {
  width: 100%;
  border: 1px solid #787878;
}

.concession-analysis-table thead {
  text-align: center;
  background-color: #dddedf;
}

.concession-analysis-table thead th {
  padding: 5px;
  border: 1px solid #000;
}

.concession-analysis-table tbody {
  border-bottom: 1px solid #000;
}

.concession-analysis-table tbody td {
  padding: 2.5px 5px;
  border-left: 1px solid #787878;
  border-right: 1px solid #787878;
}

.concession-analysis-table tbody td p {
  font-weight: bold;
  margin-bottom: 0;
}
.gcamp-tr td {
  width: 13%;
  border: 1px solid #000;
}

.swc-report-table {
  table-layout: auto !important;
  border: 1px solid black;
}
.swc-report-table th {
  border: 1px solid black !important;
}
.swc_table_header th {
  border: 1px solid black !important;
}
.bg-lightblue {
  background-color: #3876d2 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/fnbComboSales.vue